import React from 'react';
import HiringLayoffDashboard from './HiringLayoffDashboard';

/** Standalone Accounting page for Hiring / Layoff master employee list. */
export default function HiringLayoffPage() {
  return <HiringLayoffDashboard />;
}
